import { render, staticRenderFns } from "./PhotoTooLargeFileSizeModal.vue?vue&type=template&id=0fd5c444"
import script from "./PhotoTooLargeFileSizeModal.vue?vue&type=script&lang=js"
export * from "./PhotoTooLargeFileSizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports